/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Calm_Raven_RestInputs */

const en_dark_calm_raven_rest = /** @type {(inputs: Dark_Calm_Raven_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval failed`)
};

const de_dark_calm_raven_rest = /** @type {(inputs: Dark_Calm_Raven_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Approval failed" |
*
* @param {Dark_Calm_Raven_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dark_calm_raven_rest = /** @type {((inputs?: Dark_Calm_Raven_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Calm_Raven_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dark_calm_raven_rest(inputs)
	return de_dark_calm_raven_rest(inputs)
});